import { RoleName } from '../api-client/models/RoleName';

// Конфигурация доступа к разделам приложения
export interface SectionAccessConfig {
  path: string;
  label: string;
  requiredRoles: RoleName[];
  isDropdown?: boolean;
  children?: Array<{
    path: string;
    label: string;
    requiredRoles?: RoleName[];
  }>;
}

export const sectionAccessConfig: SectionAccessConfig[] = [
  {
    path: '/profile',
    label: 'Профиль',
    requiredRoles: [RoleName.USER],
  },
  {
    path: '/users',
    label: 'Пользователи',
    requiredRoles: [RoleName.ADMIN],
  },
  {
    path: '/feedback/hr-one-on-one',
    label: 'HR 1-on-1',
    requiredRoles: [RoleName.USER],
    isDropdown: true,
    children: [
      {
        path: '/feedback/hr-one-on-one',
        label: 'Все заявки',
        requiredRoles: [RoleName.HR, RoleName.ADMIN],
      },
      { path: '/feedback/hr-one-on-one/my', label: 'Мои заявки' },
    ],
  },
  {
    path: '/feedback/lawyer-consultation',
    label: 'Консультация с юристом',
    requiredRoles: [RoleName.USER],
    isDropdown: true,
    children: [
      {
        path: '/feedback/lawyer-consultation',
        label: 'Все заявки',
        requiredRoles: [RoleName.LAWYER, RoleName.ADMIN],
      },
      { path: '/feedback/lawyer-consultation/my', label: 'Мои заявки' },
    ],
  },
  {
    path: '/hiring',
    label: 'Рекрутинг',
    requiredRoles: [RoleName.RECRUITER, RoleName.ADMIN],
    isDropdown: true,
    children: [
      { path: '/hiring/referrals', label: 'Заявки' },
      { path: '/hiring/directions', label: 'Направления' },
      { path: '/hiring/my', label: 'Мои заявки' },
    ],
  },
  {
    path: '/vacation',
    label: 'Отпуска',
    requiredRoles: [RoleName.USER],
    isDropdown: true,
    children: [
      {
        path: '/vacation/applications',
        label: 'Отпуск',
        requiredRoles: [RoleName.ACCOUNTANT, RoleName.ADMIN],
      },
      {
        path: '/vacation/day-off',
        label: 'Выходной (Day Off)',
        requiredRoles: [RoleName.ACCOUNTANT, RoleName.ADMIN],
      },
      { path: '/vacation/my', label: 'Мои отпуска' },
      { path: '/vacation/day-off/my', label: 'Мои выходные' },
    ],
  },
  {
    path: '/sick-leave',
    label: 'Больничные',
    requiredRoles: [RoleName.USER],
    isDropdown: true,
    children: [
      {
        path: '/sick-leave/applications',
        label: 'Все больничные',
        requiredRoles: [RoleName.ACCOUNTANT, RoleName.ADMIN],
      },
      { path: '/sick-leave/my', label: 'Мои больничные' },
    ],
  },
];

// Маппинг путей к конфигурации для быстрого поиска
export const getPathConfig = (path: string): SectionAccessConfig | undefined => {
  return sectionAccessConfig.find((section) => {
    if (section.isDropdown && section.children) {
      return section.children.some((child) => path.startsWith(child.path));
    }
    return path.startsWith(section.path);
  });
};

// Проверка доступа к пути
export const hasAccessToPath = (roles: RoleName[], path: string): boolean => {
  const config = getPathConfig(path);
  if (!config) {
    return true;
  }

  // Если есть dropdown с детьми, проверяем доступ к конкретному ребенку
  if (config.isDropdown && config.children) {
    const child = config.children.find((c) => path.startsWith(c.path));
    if (child && child.requiredRoles && child.requiredRoles.length > 0) {
      return child.requiredRoles.some((role) => roles.includes(role));
    }
  }

  return config.requiredRoles.some((role) => roles.includes(role));
};
